import React from 'react';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-brand-cream" data-id="element-98">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-99">
        <div className="bg-white rounded-3xl p-8 md:p-16 shadow-sm border border-brand-sage relative text-center" data-id="element-100">
          <Quote className="w-12 h-12 text-brand-gold/20 absolute top-8 left-8 md:top-12 md:left-12" data-id="element-101" />

          <p className="text-xl md:text-2xl font-body italic text-brand-navy leading-relaxed relative z-10 mb-8" data-id="element-102">
            "Within 21 days of moving to a 'No-Pressure' communication style,
            the average 'Gatekeeper' parent moves from high-alert defense to
            neutral observation. Once you prove you are safe, the invitation to
            the next soccer game or birthday party becomes inevitable."
          </p>

          <div className="flex items-center justify-center gap-4" data-id="element-103">
            <div className="h-px w-12 bg-brand-gold/50" data-id="element-104"></div>
            <span className="font-heading font-semibold text-brand-gold tracking-widest uppercase text-sm" data-id="element-105">
              The Path to Peace
            </span>
            <div className="h-px w-12 bg-brand-gold/50" data-id="element-106"></div>
          </div>
        </div>
      </div>
    </section>;
}